import { useCallback, useState } from "react";

import DropdownMenu, { DropdownMenuProps } from "ds/components/DropdownMenu";

import useAssistantPanelOverlayDismiss from "../../hooks/useOverlayDismiss";
import styles from "./styles.module.css";

type AssistantPanelDropdownMenuProps<T> = Omit<
  DropdownMenuProps<T>,
  "isOpen" | "isNonModal" | "onOpenChange"
>;

const AssistantPanelDropdownMenu = <T extends object>(
  menuProps: AssistantPanelDropdownMenuProps<T>
) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);
  const { wrapperRef, overlayProps } = useAssistantPanelOverlayDismiss({ isOpen, onClose: close });

  return (
    <div ref={wrapperRef} className={styles.wrapper}>
      <DropdownMenu
        {...menuProps}
        {...overlayProps}
        isNonModal
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      />
    </div>
  );
};

export default AssistantPanelDropdownMenu;
